import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=773fe762"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=773fe762&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports